export const getLockOwnerName = (error: any): string | null => {
  return error?.lockOwnerName ?? error?.data?.lockOwnerName ?? error?.data?.LockOwnerName ?? null;
};
